export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/orderCancelled.0e762d41.svg","height":24,"width":24};